import { findCategory } from "@/lib/discoverCategories";
import blogDefault from "@/assets/blog/blog-default.jpg";

/**
 * Resolve the feature image for a blog post, falling back to the
 * Discover category image and finally a generic blog default so
 * articles always carry a visual.
 */
export const resolvePostImage = (
  imageUrl?: string | null,
  discoverCategory?: string | null,
): string => {
  if (imageUrl) return imageUrl;
  const cat = findCategory(discoverCategory ?? undefined);
  if (cat?.image) return cat.image;
  return blogDefault;
};
